module.exports = __webpack_public_path__ + "static/media/logo_wee_digital.cfc85369.svg";